module.exports = __webpack_public_path__ + "img/6-4.26bdd530.png";